import axios from 'axios';
import { CHECK_EMAIL_AVAILABLE, CHECK_EMAIL_AVAILABLE_ERROR } from './index';

export async function checkEmailAvailable(email) {
    const params = new FormData();
    params.append('email', email);
    params.append('csrfToken', window.csrfToken);

    try {
        const response = await axios.post('/u/registration/emailAvailable',
            params, {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        return {
            type: CHECK_EMAIL_AVAILABLE,
            payload: response
        };
    } catch (error) {
        return {
            type: CHECK_EMAIL_AVAILABLE_ERROR,
            payload: error
        };
    }
}
